import { AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { AppState } from '../../../store';
import megatron from '@stencil/megatron';
import querystring from 'query-string';
import { prepareThankyouJourneyDetailsRequest, prepareBookingStatusRequest, prepareFeedbackStatusAPI, prepareSurveyAPICall } from './../Api';
import { updateThankyouPageInfo, updateBookingStatus, setThankyouPageError, setFeedBackStatus } from './actions';
import { pushDataToNewrelic } from './../../Common/Utils'

export const fetchJourneyDetails = (props): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {

    try {

      const state = getState();
      const thankyouStore = state['thankyou'];
      const {
        flavour,
        payment,
        trn,
        vertical_txn_id,
        pay_txn_id,
        pay_session_id,
        pay_status,
        request_id,
        pg,
        format
      } = thankyouStore;

      const url = prepareThankyouJourneyDetailsRequest({
        flavour,
        payment,
        trn,
        vertical_txn_id,
        pay_txn_id,
        pay_session_id,
        pay_status,
        request_id,
        pg,
        format
      });

      let data;

      data = await megatron({
        name: 'Bus Thankyou',
        type: 'GET',
        url,
        credentials: 'include',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      });
      if (data && data.data) {
        dispatch(updateThankyouPageInfo({ data: data.data }));
        if (payment == 'success') {
          dispatch(getBookingStatus({ count: 1 }));
        }
      }
      pushDataToNewrelic(`thankyoupage=true&value=success`);

    } catch (err) {
      dispatch(setThankyouPageError({ error: true }));
      pushDataToNewrelic(`thankyoupage=true&value=fail`);

      console.trace(err);
    }
    finally {
    }
  };
}


export const getBookingStatus = (props): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {

    try {
      const state = getState();
      const userState = state['user'];
      const isLoggedIn = userState.isLoggedIn || false;
      const thankyouStore = state['thankyou'];
      const {
        flavour,
        trn,
        vertical_txn_id,
        status
      } = thankyouStore;

      const url = prepareBookingStatusRequest({
        flavour,
        trn,
        vertical_txn_id
      });

      let data;

      data = await megatron({
        name: 'Bus Thankyou',
        type: 'POST',
        url,
        credentials: 'include',
        requestData: querystring.stringify({ udf2: 'True', is_rnpl: false, fmnid: vertical_txn_id }),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      });
      if (data && data.status && data.status.length && data.status[0].status != status) {
        dispatch(updateBookingStatus({ status: data.status[0].status }));
      }

      if (data && data.status && data.status.length) {
        if (data.status[0].status.toLowerCase() == 'processing' && props.count < 3) {

          setTimeout(function () { dispatch(getBookingStatus({ count: props.count + 1 })) }, 2000);
        }
      }
    } catch (err) {
      pushDataToNewrelic(`thankyoupage=true&value=statusfail`);
      console.trace(err);
    }
    finally {

    }
  };
}

export const getFeedBackStatus = (props): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {

    try {
      const state = getState();
      const thankyouStore = state['thankyou'];
      const {
        vertical_txn_id
      } = thankyouStore;

      const url = prepareFeedbackStatusAPI({ vertical_txn_id });

      let data;

      data = await megatron({
        name: 'Bus Thankyou Feedback status',
        type: 'GET',
        url,
        credentials: 'include',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      });
      if (!data || !Object.keys(data.status).length) {
        dispatch(setFeedBackStatus({ status: true }));
      } else {
        dispatch(setFeedBackStatus({ status: false }));
      }

    } catch (err) {
      dispatch(setFeedBackStatus({ status: false }));


      console.trace(err);
    }
    finally {
    }
  };
}

export const submitFeedbackcall = (props): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {

    try {
      const { userRating, redirect = false } = props;
      const state = getState();
      const thankyouStore = state['thankyou'];
      const {
        vertical_txn_id,
        flavour,
        status
      } = thankyouStore;

      const url = prepareSurveyAPICall({ bookingId: vertical_txn_id, bookingStatus: status, source: flavour == 'v2' ? 'DWEB' : 'MWEB', npsRating: userRating });

      let data;

      data = await megatron({
        name: 'Bus Thankyou Feedback status',
        type: 'GET',
        url,
        credentials: 'include',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      });
      if (data && data.responseUrl && data.responseUrl.length) {
        if (redirect) {
          window.open(data.responseUrl);
        }
      }
    } catch (err) {
      console.trace(err);
    }
  };
}
